import React, { useEffect, useState } from "react";
import Yaralanma from "./Yaralanma.js";
import Vefat from "./Vefat.js";
import MaddiHasar from "./MaddiHasar.js";
import { Helmet } from "react-helmet-async";

import axios from "axios";
const App = () => {
  const [name, setName] = useState();
  const [mail, setMail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [errorField, SetErrorField] = useState("");
  const [success, SetSuccess] = useState(false);
  const [data, setData] = useState();
  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [selected1, setSelected1] = useState("");
  const cities = [
    "Adana",
    "Adıyaman",
    "Afyonkarahisar",
    "Ağrı",
    "Aksaray",
    "Amasya",
    "Ankara",
    "Antalya",
    "Ardahan",
    "Artvin",
    "Aydın",
    "Balıkesir",
    "Bartın",
    "Batman",
    "Bayburt",
    "Bilecik",
    "Bingöl",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Çanakkale",
    "Çankırı",
    "Çorum",
    "Denizli",
    "Diyarbakır",
    "Düzce",
    "Edirne",
    "Elazığ",
    "Erzincan",
    "Erzurum",
    "Eskişehir",
    "Gaziantep",
    "Giresun",
    "Gümüşhane",
    "Hakkâri",
    "Hatay",
    "Iğdır",
    "Isparta",
    "İstanbul",
    "İzmir",
    "Kahramanmaraş",
    "Karabük",
    "Karaman",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kilis",
    "Kırıkkale",
    "Kırklareli",
    "Kırşehir",
    "Kocaeli",
    "Konya",
    "Kütahya",
    "Malatya",
    "Manisa",
    "Mardin",
    "Mersin",
    "Muğla",
    "Muş",
    "Nevşehir",
    "Niğde",
    "Ordu",
    "Osmaniye",
    "Rize",
    "Sakarya",
    "Samsun",
    "Şanlıurfa",
    "Siirt",
    "Sinop",
    "Sivas",
    "Şırnak",
    "Tekirdağ",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Uşak",
    "Van",
    "Yalova",
    "Yozgat",
    "Zonguldak",
  ];

  const handleSelectChange = (e) => {
    setSelected1(e.target.value);
  };
  useEffect(() => {
    // let item_brand = "Schneider Electric";

    // if (item_brand === "Schneider Electric" || item_brand === "Square D") {
    //   if (window && window.dataLayer) {
    //     window.dataLayer.push({
    //       event: "SE_view_item",
    //       ecommerce: {
    //         currency: "USD",
    //         value: 199.99,
    //         items: [
    //           {
    //             item_id: "id12345",
    //             item_name: "Schneider Electric,PUSHBUTTON +OPTIONS",
    //             item_category: 'Industrial Automation',
    //             item_category2: 'Contactors',
    //             price: 199.99,
    //             quantity: 1,
    //             item_brand: "Schneider Electric"
    //           }
    //         ]
    //       }
    //     });
    //   }
    // }

    // if (item_brand === "Schneider Electric" || item_brand === "Square D") {
    //   if (window && window.dataLayer) {
    //     window.dataLayer.push({
    //       event: "SE_add_to_cart",
    //       ecommerce: {
    //         currency: "USD",
    //         value: 199.99,
    //         items: [
    //           {
    //             item_id: "id12345",
    //             item_name: "Schneider Electric,PUSHBUTTON +OPTIONS",
    //             item_category: 'Industrial Automation',
    //             item_category2: 'Contactors',
    //             price: 199.99,
    //             quantity: 1,
    //             item_brand: "Schneider Electric"
    //           }
    //         ]
    //       }
    //     });
    //   }
    // }

    // window.dataLayer = window.dataLayer || [];

    // var allItems = [
    //   {
    //     item_id: 'LC1D32B7',
    //     item_name: 'Schneider Electric TeSys D Contactor 32A',
    //     item_brand: 'Square D',
    //     item_category: 'Industrial Automation',
    //     item_category2: 'Contactors',
    //     price: 129.99,
    //     quantity: 1
    //   },
    //   {
    //     item_id: 'XZ923-A1',
    //     item_name: 'XZY 4000 Power Module',
    //     item_brand: 'XXX Corp',
    //     item_category: 'Power Systems',
    //     item_category2: 'Modules',
    //     price: 89.90,
    //     quantity: 1
    //   },
    //   {
    //     item_id: 'GV2ME14',
    //     item_name: 'Schneider Electric Motor Circuit Breaker',
    //     item_brand: 'Square D',
    //     item_category: 'Industrial Automation',
    //     item_category2: 'Circuit Breakers',
    //     price: 219.91,
    //     quantity: 1
    //   }
    // ];

    // // Filter by brands
    // var targetBrands = ['Square D', 'Schneider Electric'];
    // var filteredItems = allItems.filter(function (item) {
    //   return targetBrands.includes(item.item_brand);
    // });

    // if (filteredItems.length > 0) {
    //   var totalValue = filteredItems.reduce(function (sum, item) {
    //     return sum + (item.price * item.quantity);
    //   }, 0);

    //   window.dataLayer.push({
    //     event: 'SE_begin_checkout',
    //     ecommerce: {
    //       currency: 'USD',
    //       value: totalValue,
    //       items: filteredItems
    //     }
    //   });
    // }


    // window.dataLayer = window.dataLayer || [];

    // var purchasedItems = [
    //   {
    //     item_id: 'LC1D32B7',
    //     item_name: 'Schneider Electric TeSys D Contactor 32A',
    //     item_brand: 'Square D',
    //     item_category: 'Industrial Automation',
    //     item_category2: 'Contactors',
    //     price: 129.99,
    //     quantity: 1
    //   },
    //   {
    //     item_id: 'AB-555X',
    //     item_name: 'PWR-V8 Turbo Drive',
    //     item_brand: 'YYY Systems',
    //     item_category: 'Drives & Controls',
    //     item_category2: 'Drives',
    //     price: 99.90,
    //     quantity: 1
    //   },
    //   {
    //     item_id: 'GV2ME14',
    //     item_name: 'Schneider Electric Motor Circuit Breaker',
    //     item_brand: 'Square D',
    //     item_category: 'Industrial Automation',
    //     item_category2: 'Circuit Breakers',
    //     price: 219.91,
    //     quantity: 1
    //   }
    // ];

    // // Filter by brands
    // var targetBrands = ['Square D', 'Schneider Electric'];
    // var filteredPurchased = purchasedItems.filter(function (item) {
    //   return targetBrands.includes(item.item_brand);
    // });

    // if (filteredPurchased.length > 0) {
    //   var value = filteredPurchased.reduce(function (sum, item) {
    //     return sum + (item.price * item.quantity);
    //   }, 0);

    //   window.dataLayer.push({
    //     event: 'SE_purchase',

    //     ecommerce: {
    //       transaction_id: 'SE-ORDER-20250703-01',
    //       value: value,
    //       tax: 38.00,
    //       shipping: 15.00,
    //       currency: 'USD',
    //       items: filteredPurchased
    //     }
    //   });
    // }

    if (window && window.dataLayer) {
        window.dataLayer.push({
          event: "se_view_item",
          ecommerce: {
            currency: "USD",
            value: 199.99,
            items: [
              {
                item_name: "Schneider Electric,PUSHBUTTON +OPTIONS",
                item_id: "id12345",
                price: 199.99,
                quantity: 1,
                item_brand: "Schneider Electric"
              }
            ]
          }
        });
      }





    // let item_brand = "Schneider Electric2";
    // if (item_brand === "Schneider Electric") {
    //   if (window && window.dataLayer) {
    //     window.dataLayer.push({
    //       event: "test_event",
    //       ecommerce: {
    //         currency: "USD",
    //         value: 199.99,
    //         items: [
    //           {
    //             item_name: "Schneider Electric,PUSHBUTTON +OPTIONS",
    //             item_id: "id12345",
    //             price: 199.99,
    //             quantity: 1,
    //             item_brand: "Schneider Electric"
    //           }
    //         ]
    //       }
    //     });
    //   }
    // }
    // else {
    //   if (window && window.dataLayer) {
    //     window.dataLayer.push({
    //       event: "test_event_2",
    //       ecommerce: {
    //         currency: "USD",
    //         value: 199.99,
    //         items: [
    //           {
    //             item_name: "Schneider Electric,PUSHBUTTON +OPTIONS",
    //             item_id: "id12345",
    //             price: 199.99,
    //             quantity: 1,
    //             item_brand: "Schneider Electric"
    //           }
    //         ]
    //       }
    //     });
    //   }
    // }

    // if (item_brand === "SQUARE D") {
    //   window.dataLayer = window.dataLayer || [];
    //   window.dataLayer.push({
    //     event: 'add_to_cart_schneider',
    //     ecommerce: {
    //       currency: 'EUR',
    //       value: 129.99,
    //       items: [{
    //         item_id: 'LC1D32B7',
    //         item_name: 'Schneider Electric TeSys D Kontaktör 32A 3P 24V',
    //         item_brand: 'SQUARE D',
    //         item_category: 'Endüstriyel Otomasyon',
    //         item_category2: 'Kontaktörler',
    //         price: 129.99,
    //         quantity: 1
    //       }]
    //     }
    //   });
    // }



  }, []);
  return (
    <div >
      <Helmet>
        <title>
          Trafik Kazası Tazminatı Hesaplama - Yaralanma, Vefat & Maddi Hasar
        </title>
        <meta
          name="description"
          content="Trafik kazası sonucu yaralanma, vefat ya da maddi hasar durumlarınız için tazminatınızı hızlıca hesaplayın. Uygun formu doldurarak ücretsiz danışmanlık alın!"
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <h1 className="text-center mr-5 font-bold text-xl text-black">Trafik Tazminatınızı Hızlıca Hesaplayın</h1>
      <form
        className=" px-8 pt-6 pb-8  mt-2 text-xs mx-8 sm:mx-0"
        style={{ height: "600px" }}
      >
        {/* <div className='flex justify-center  mb-2 bg-red-300 rounded-lg mx-auto'>
                        <a href="/admin" className='text-base font-bold'>Müşteri Listesi</a>
                    </div> */}
        <div className="flex justify-center mb-2">
          {/* <div
            className={`px-3 rounded-lg font-semibold py-1 cursor-pointer ' ${
              checked1
                ? "bg-blue-400 outline outline-1 outline-gray-400"
                : "bg-white"
            } `}
            onClick={() => {
              setChecked1(true);
              setChecked2(false);
              setChecked3(false);
            }}
          >
            Yaralanmalı Trafik Kazası
          </div> */}
          {/* <div
            className={` px-3 rounded-lg font-semibold mx-5 py-1 cursor-pointer ' ${
              checked2
                ? "bg-blue-400 outline outline-1 outline-gray-400"
                : "bg-white"
            }`}
            onClick={() => {
              setChecked1(false);
              setChecked2(true);
              setChecked3(false);
            }}
          >
            Ölümlü Trafik Kazası
          </div> */}
          {/* <div
            className={` px-3 rounded-lg font-semibold py-1 cursor-pointer ' ${
              checked3
                ? "bg-blue-400 outline outline-1 outline-gray-400"
                : "bg-white"
            }`}
            onClick={() => {
              setChecked1(false);
              setChecked2(false);
              setChecked3(true);
            }}
          >
            Maddi Hasarlı Trafik Kazası
          </div> */}
        </div>
        {checked1 && (
          <div>
            <Yaralanma />
          </div>
        )}
        {checked2 && (
          <div>
            <Vefat />
          </div>
        )}
        {checked3 && (
          <div>
            <MaddiHasar />
          </div>
        )}
      </form>
    </div>
  );
};

export default App;
